import React from "react";
import { Container, Row, Col, Image, Collapse, Alert } from 'react-bootstrap';
import BeadMeerBanner from "./component/BeadMeerBanner";

function Help(props) {
    let { name } = props.match.params;

    // if (name === undefined) {
    //     name = 'privacy';
    // }
    let divStyle = {
        paddingTop: "1vh",
        paddingBottom: "1vh",
        paddingRight: "3vw",
        paddingLeft: "3vw"
    }

    if (name === 'feedback') {
        return (
            <Container fluid>
                <br />
                <BeadMeerBanner />
                <br />
                <div style={divStyle} align="center">
                    {/* <h2>Feedback</h2> */}
                    <br />
                    {/* <p>Please e-mail to feedback@beadmeer.com</p> */}
                    <p>
                        <br />
                        <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSe-eC84MClx1URRmlC-gbOplBF35iVhS6cqYlM-1UWpsS4X-A/viewform?embedded=true" width="90%" height="1600" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
                     </p>
                </div>
            </Container>
        )
    } else if (name === 'beadmeerbot') {
        return (
            <Container fluid>
                <br />
                <BeadMeerBanner />
                <br />
                <div style={divStyle} align="left">
                    <h2>BeadMeerBot</h2>
                    <i>Last updated: May 7, 2021</i><br />
                    <br />
                    <p>BeadMeerBot is the generic name for BeadMeer's web crawler. You can identify our BeadMeerBots by looking at the user agent string in the request.</p>

                    <h3>How BeadMeerBot accesses your site</h3>
                    <p>For most sites, BeadMeerBot shouldn't access your site more than once every few seconds on average. However, due to delays it's possible that the rate will appear to be slightly higher over short period.</p>

                    <h3>Blocking BeadMeerBot from visiting your site</h3>
                    <p>If you want to prevent BeadMeerBot from crawling content on your site, you have a number of options.<br />
                        <ol>
                            <li><b>Remove the content</b>: Removing content from your site is the best way to ensure that it won't appear in BeadMeer Search, or anywhere.</li>
                            <li><b>Password-protect your files</b>: If you have confidential or private content that you don't want to appear in BeadMeer search results, the simplest and most effective way to block private URLs from appearing is to store them in a password-protected directory on your site server.</li>
                            <li><b>Update your robots.txt file</b>: BeadMeer's automated crawlers support the <a href="https://datatracker.ietf.org/doc/html/draft-koster-rep">Robots Exclusion Protocol ("REP")</a>. This means that before crawling a site, BeadMeer's crawlers download and parse the site's robots.txt file to extract information about which parts of the site may be crawled. Please check <a href="https://www.robotstxt.org/robotstxt.html">here</a> for finding out how to use this feature.</li>
                        </ol></p>

                    <h3>Our User Agents</h3>
                    <p>
                        <ul>
                            <li>BeadMeerBot (token: BeadMeerBot)<br />
                                <ul>
                                    <li>Mozilla/5.0 (compatible; BeadMeerBot/0.9; +https://beadmeer.com/help/beadmeerbot)</li>
                                    <li>Mozilla/5.0 AppleWebKit/537.36 (KHTML, like Gecko; compatible; BeadMeerBot/0.9; +https://beadmeer.com/help/beadmeerbot) Chrome/<i>W.X.Y.Z</i> Safari/537.36</li>
                                    <li>BeadMeerBot/0.9 (+https://beadmeer.com/help/beadmeerbot)</li>
                                </ul>
                            </li>
                        </ul>
                    </p>
                    * <i>W.X.Y.Z</i> in user agents is actually a placeholder that represents the version of the Chrome browser used by that user agent.

                </div>

            </Container>
        )
        // } else if (name === 'refund') {
        //     return (
        //         <div style={divStyle}>
        //             <h2>Fair Refund Policy</h2>
        //             <i>Last updated: May 4, 2021</i><br />
        //             <br />
        //             <p>We want to be fair to our customers while at the same time protecting our company from abuse. You will get a refund only if you cancel your account. When canceling your account, you will effectively forgo any Bonus Service Credit your prepayment may have entitled you to.</p>
        //             <p>Our refund policy is simple.</p>
        //             <ul>
        //                 <li>If the Balance is $3000 or more, we will refund 60% of the Balance</li>
        //                 <li>If the Balance $500 or more, but less than $3000, we will refund 70% of the Balance</li>
        //                 <li>If the Balance is less than $500, we will refund 80% of the Balance. </li>
        //             </ul>
        //             <p>The account balance used for calculating the amount of refund is the balance on the date when the refund is processed.</p>
        //             <p>Transaction cost and sales tax adjustments will be subtracted from the refund amount as required.</p>
        //         </div>
        //     )
    } else if (name === 'faq' || name === undefined) {
        return (
            <Container fluid>
                <br />
                <BeadMeerBanner />
                <br />
                <Row className="justify-content-center">
                    <Col align="left">
                        <div style={divStyle}>
                            <h2>Frequently Asked Questions</h2>
                            <i>Last updated: July 1, 2021</i><br />
                            <br />

                            <h3>1. What is BeadMeer&#8482;?</h3>
                            <p>BeadMeer is a jewellery pattern search engine provided by Oeuf Laboratory under SoftOpinion Group Corporation. We do NOT collect or store these patterns/images but create and manage the references for helping users to get inspirations by various patterns from multiple sources.</p>
                            <p>About: <a href="/help/beadmeerbot">BeadMeerBot</a></p>

                            <h3>2. Does this service cost anything?</h3>

                            <p>No, the visitors may use the service without charges unless one violates <a href="/policy/restrictions">Use Restriction Policy</a>. Please check <a href="/terms">Terms of Service</a> for details.</p>

                            <h3>3. How do I use this search engine?</h3>

                            <p>
                                <ol>
                                    <li>Open BeadMeer from any browser.</li>
                                    <li>Enter the keywords you would like to search.</li>
                                    <li>Click on the item from the displayed candidates. This will bring you to the source of the selected pattern.</li>
                                    <li>Do this over and over again!</li>
                                </ol>
                            </p>

                            <h3>4. Why doesn't you show the patterns to my website?</h3>

                            <p>As a research project, small or personal websites are not currently included. If you have a commercial jewellery pattern library (100+ ideas/items) and want us to add, please contact us via <a href="/help/feedback">Feedback</a>.</p>

                            <h3>5. I would like to place the advertisement to my business product/service.</h3>

                            <p>Please use <a href="/help/feedback">Feedback</a> with details to contact us.</p>

                            {/* <h2>Privacy Policy</h2>
    <br />
    <p>Your privacy is important to us. It is SoftOpinion Group Corporation's policy to respect your privacy regarding any information we may collect from you across our website, <a href="https://BeadMeer.com">https://BeadMeer.com</a>, and other sites we own and operate.</p>
    <p>We only ask for personal information when we truly need it to provide a service to you. We collect it by fair and lawful means, with your knowledge and consent. We also let you know why we’re collecting it and how it will be used.</p>
    <p>We only retain collected information for as long as necessary to provide you with your requested service. What data we store, we’ll protect within commercially acceptable means to prevent loss and theft, as well as unauthorised access, disclosure, copying, use or modification.</p>
    <p>We don’t share any personally identifying information publicly or with third-parties, except when required to by law.</p>
    <p>Our website may link to external sites that are not operated by us. Please be aware that we have no control over the content and practices of these sites, and cannot accept responsibility or liability for their respective privacy policies.</p>
    <p>You are free to refuse our request for your personal information, with the understanding that we may be unable to provide you with some of your desired services.</p>
    <p>Your continued use of our website will be regarded as acceptance of our practices around privacy and personal information. If you have any questions about how we handle user data and personal information, feel free to contact us.</p>
    <p>This policy is effective as of 20 August 2020.</p>  */}
                        </div>
                    </Col>
                </Row>
            </Container>
        );
    } else {
        return (
            <Container fluid>
                <br />
                <BeadMeerBanner />
                <div style={divStyle}>
                    {/* <h2>Help! BeadMeer</h2> */}
                    <br />
                    <ul>
                        <li><a href="/help/faq">Frequently Asked Questions</a></li>
                        <li><a href="/help/beadmeerbot">What is BeadMeerBot?</a></li>
                        {/* <li><a href="/policy/beadmeerbot">BeadMeerbot Policy</a></li> */}
                        {/* <li><a href="/policy/cancellation">Cancellation Policy</a></li> */}
                        {/* <li><a href="/policy/refund">Fair Refund Policy</a></li> */}
                    </ul>
                </div>
            </Container>
        )
    }
}


export default Help;